import axios from 'axios'
import { Toast } from 'vant'

function goLogin() {
  const module = location.pathname.split('/')[1] || 'common'
  // 不同模块使用自己的login页面做特别处理，参考/official/login
  const authServer = `${location.origin}/${module}/login`
  const authServerUrl = `${authServer}?service=${encodeURIComponent(
    location.href,
  )}`
  if (!decodeURI(location.pathname).includes('/login')) {
    //当前已经在登陆页不需要再有路由变化，处理同个页面多个401触发多次goLogin的情况
    location.replace(authServerUrl)
  }
}

const codeMessage = {
  OFF_LINE: '抱歉，您貌似还没连接到网络，请检查网络连接',
  200: '服务器成功返回请求的数据',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '抱歉，您貌似还没有登录',
  403: '抱歉，您没有权限访问该页面',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器',
  502: '网关错误',
  503: '服务不可用，服务器暂时过载或维护',
  504: '网关超时',
}

function createError(responseError) {
  let [code, errorMsg, response] = ['', '', {}]

  if (axios.isCancel(responseError)) {
    // 主动取消的请求
    console.warn(responseError.message)
    return
  }
  // 请求已经发送，并且服务器有返回
  if (responseError.response || responseError.status) {
    response = responseError.response || responseError
    // 错误码\错误信息
    code = response.status
    errorMsg = response.data.message || response.data.msg
  } else if (responseError.request) {
    // 请求已发送但是没有收到服务器响应
    if ('onLine' in navigator && navigator.onLine === false) {
      code = 'OFF_LINE'
    } else if (responseError.code === 'ECONNABORTED') {
      code = 504
      errorMsg = `网络请求超时(${responseError.config.timeout}ms)`
    }
  } else {
    // 请求未发出
    errorMsg = responseError
  }

  // 未登录
  if (code === 401) {
    const msg = response.data.message || response.data.msg
    if (msg && msg !== 'unauthorized') {
      Toast(msg)
      setTimeout(goLogin, 1500)
    } else {
      goLogin()
    }
  }

  if (!code) {
    code = -1
  }

  if (!errorMsg) {
    errorMsg =
      codeMessage[code] || response.statusText || `抱歉，当前请求异常(${code})`
  }

  if (
    response.config.url.indexOf('/ep-garden-candidate/api/resume/parse') ===
      -1 &&
    code !== 401
  ) {
    Toast(`请求错误:${code}:${errorMsg}`)
  }

  const error = new Error(errorMsg)
  error.name = code
  error.message = errorMsg
  error.response = response

  return Promise.reject(error)
}

axios.interceptors.request.use(config => {
  if (!config.timeout) {
    config.timeout = 60 * 1000
  }

  config.retry = 2
  config.retryDelay = 1000

  config.withCredentials = true

  return config
})

axios.interceptors.response.use(response => {
  const responseData = response.data
  if (!response.config.url.includes('accounts/api')) {
    if (response.config.method === 'post') {
      return responseData
    } else {
      if (responseData.code === 1) {
        if (response.config.method !== 'get') {
          Toast('操作成功')
        }
        return responseData.data
      } else {
        Toast(responseData.msg || responseData.message)
        return Promise.reject(responseData.msg || responseData.message)
      }
    }
  } else {
    return responseData
  }
}, createError)

let zgyApiHost = ''
let growthUrl =
  'https://m.yuanfudao.biz/act/recruitment-growth?keyfrom=tutor-resume' // 招聘增长活动页
let frogUrl = 'https://frog.yuanfudao.biz/statV2/plain' //埋点
let yfdApiHost = ''
let yfdMHost = ''
if (location.hostname.includes('test') || location.hostname.includes('local')) {
  zgyApiHost = 'garden-test.zhenguanyu.com'
  yfdApiHost = 'garden-h5-test.yuanfudao.biz'
  yfdMHost = 'garden-test.zhenguanyu.com'
} else {
  zgyApiHost = 'garden.yuanfudao.com'
  yfdApiHost = 'garden.yuanfudao.com'
  yfdMHost = 'm.yuanfudao.com'
  growthUrl =
    'https://recruit.yuanfudao.com/act/recruitment-growth?keyfrom=tutor-resume'
  frogUrl = 'https://frog.yuanfudao.com/statV2/plain'
}
function request(url, options, apiHost) {
  const method = (options && options.method.toLowerCase()) || 'get'
  const requestUrl = `${window.location.protocol}//${apiHost}${url}`
  return axios[method](requestUrl, options && options.body)
    .then(res => res)
    .catch(err => Promise.reject(err))
}
function requestZgy(url, options) {
  return request(url, options, zgyApiHost)
}
function requestYfd(url, options) {
  return request(url, options, yfdApiHost)
}
function requestYfdM(url, options) {
  return request(url, options, yfdMHost)
}

export {
  goLogin,
  growthUrl,
  frogUrl,
  requestZgy,
  requestYfd,
  requestYfdM,
  yfdApiHost,
}
